import React, { useState, useEffect } from 'react';
import APIs from '../../APIs'; // Adjust the path as needed to where your APIs instance is defined
import { Link } from 'react-router-dom';
const Services = () => {
      const [toastData, setToastData] = useState(null);
      const [services, setServices] = useState([]);

  useEffect(() => {
        getAllServices();
    }, []);

    const getAllServices = async () => {

        try {
            const response = await APIs.get('service/getAllService', {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            console.log('Get Service Response -', response.data);

            if (response.data.status === "success") {
                setServices(response.data.data);
            }

        } catch (error) {
            if (error.response) {
                const { statusCode, message } = error.response.data;

                if (statusCode === 401) {
                    setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
                } else if (statusCode === 422) {
                    setToastData({ title: 'Service', message: message, type: 'info', id: Date.now() });
                } else if (statusCode === 409) {
                    setToastData({ title: 'Service', message: message, type: 'warning', id: Date.now() });
                } else if (statusCode === 400 || statusCode === 404) {
                    setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
                } else if (statusCode === 500) {
                    setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
                }
            } else {
                setToastData({ title: 'Service', message: error.message, type: 'danger', id: Date.now() });
            }
        }
    }
   // console.log('Services List -', services);
  return (
    <>
      {/* Title Bar */}
     
      {/* Title Bar End */}

      {/* Page Content */}
      <div className="page-content">
        {/* Portfolio Grid Col 3 */}
        <section className="section-xl">
          <div className="container">
            <div className="row eagle-element-posts-wrapper">
              {services.length === 0 ? (
                <>
              <img
              src="/images/nodatafoundimg.png" // replace with your image path
              alt="No documents found"
              className="img-fluid mb-3"
              style={{ maxWidth: "200px" }}
              />
              
                  <p>No services found.</p>
                  </>
                ) : (
                  services.map((service, idx) => (
                    <article className="eagle-portfolio-style-1 col-md-4" key={service._id || idx}>
                      <div className="pbminfotech-post-content">
                        <div className="eagle-featured-img-wrapper">
                          <div className="eagle-featured-wrapper">
                            <img
                              src={service.service_image || "images/homepage-1/service/service-img-01.jpg"}
                              alt={service.service_name}
                            />
                          </div>
                        </div>
                        <div className="pbminfotech-box-content">
                          <div className="pbminfotech-titlebox">
                            <h3 className="eagle-portfolio-title">
                              <Link to={`/service-details/${service.service_id || idx}`}>{service.service_name}</Link>
                            </h3>
                            <p className="eagle-portfolio-decription mb-0">
                              {service.service_description}
                            </p>
                          </div>
                        </div>
                        <Link to={`/service-details/${service.service_id || idx}`} className="eagle-link"></Link>
                      </div>
                    </article>
                  ))
                )}
              
            </div>
          </div>
        </section>
        {/* Portfolio Grid Col 3 End */}
      </div>
      {/* Page Content End */}
    </>
  );
};

export default Services;
